// extracted by mini-css-extract-plugin
export var MuiPopperRoot = "t_bz";
export var MuiTooltipPopper = "t_bB";
export var button = "t_bJ";
export var icon = "t_j";
export var iconWrapper = "t_bG";
export var qlTooltipLimited = "t_bC";
export var title = "t_bH";
export var wpBlockList = "t_bD";
export var wrapper = "t_bF";